import { ButtonBase } from '@mui/material';
import { useRef } from 'react';
import { flaggedStyles, regionSelectedStyles, regionStyles } from './DesignCanvas.styles';
import { useReveal } from './useReveal';

interface Props {
  selected: boolean;
  /** An issue is about this part. */
  flagged: boolean;
  /** See `useReveal`. */
  shown?: number;
  /** Where on its sheet the part stands, for a strip. */
  sx?: object;
  onSelect: () => void;
  children: React.ReactNode;
}

/**
 * A part of a sheet that is set up in the inspector and not composed on the page: a header or
 * footer strip, the summary, the checkpoints. It is drawn as it prints and is one button,
 * which selects it. Nothing in it is dragged.
 */
const Region: React.FC<Props> = ({ selected, flagged, shown, sx, onSelect, children }) => {
  const node = useRef<HTMLDivElement>(null);

  useReveal(node, shown);

  return (
    <ButtonBase
      ref={node}
      component="div"
      disableRipple
      aria-current={selected || undefined}
      sx={[regionStyles, flagged && flaggedStyles, selected && regionSelectedStyles, sx ?? false]}
      onClick={(event: React.MouseEvent) => {
        // Not the page the part lies on.
        event.stopPropagation();
        onSelect();
      }}
    >
      {children}
    </ButtonBase>
  );
};

export default Region;
